import React from "react";
import godparentsImage from "./images/godparents.webp";
import lineHeartImage from "./images/line-heart.webp";
import "./Godparents.scss";
import OnScrollAnimationWrapper from "../common/OnScrollAnimationWrapper";
/// TODO: delete
export default function Godparents({ t }) {
  return (
    <div className="p-top-8 p-bottom-8" id="godparents">
      <div className="container text-center p-block-3">
        <h1 className="text-center m-bottom-5 text-primary">{t.godparents}</h1>
        <div className="relative godparents-image m-inline-auto">
          <div className="line-heart-image">
            <OnScrollAnimationWrapper
              animation={"animation-slide-fade-in-right"}
              triggerOnce={false}
              classNameInitialState={`opacity-0 animation-duration-1s animation-custom-style`}
            >
              <img src={lineHeartImage} alt="Line Heart" width="100%" height="auto" />
            </OnScrollAnimationWrapper>
          </div>
          <img src={godparentsImage} alt="Godparents" className="godparents-image-style" width="100%" height="auto" />
        </div>
        <h4 className="text-center m-bottom-4 m-top-1 font-body text-primary">{t.godparentsFamily}</h4>
        <div className="text-body text-justify-xsm text-center m-top-4 m-inline-auto col-7 col-12-xsm m-bottom-4 text-primary text-justify">{t.godparentsText} <strong>{t.godparentsYes}</strong>{t.godparentsText2}{" "}
          <strong>{t.godparentsNames}</strong> {t.godparentsText3}</div>
      </div>
    </div>
  );
}
